//Footer L1 functionality for mobile
document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll(".footer-block__heading");

  headings?.forEach(function (heading) {
    heading.addEventListener("click", function () {
      // Toggle the 'active' class on click
      heading.classList.toggle("active");

      // Close other open details
      headings.forEach(function (otherHeading) {
        if (
          otherHeading !== heading &&
          otherHeading.classList.contains("active")
        ) {
          otherHeading.classList.remove("active");
        }
      });
    });
  });
});